import { type Font, type RenderedText, TextBounds, TextProperties } from 'etcher-wasm';
type SessionId = string;

export enum MessageType {
    CreateSession = 'create-session',
    DestroySession = 'destroy-session',
    LoadFont = 'load-font',
    RenderText = 'render-text',
}

export interface DestroySessionPayload {
    sessionId: SessionId;
}

export interface LoadFontPayload {
    sessionId: SessionId;
    font: ArrayBuffer;
}

export interface RenderTextPayload {
    sessionId: SessionId;
    text: string;
    bounds: TextBounds;
    properties: TextProperties;
}

export type MessagePayload = DestroySessionPayload | LoadFontPayload | RenderTextPayload | null;

export type WorkerMessage = {
    id: string;
    type: MessageType;
    payload: MessagePayload;
};

export type CreateSessionResult = {
    sessionId: SessionId;
};
export type DestroySessionResult = void;
export type LoadFontResult = Array<Font>;
export type RenderTextResult = RenderedText;
export type Result = CreateSessionResult | DestroySessionResult | LoadFontResult | RenderTextResult;

export type CreateSessionCallback = (data: CreateSessionResult) => void;
export type DestroySessionCallback = (data: DestroySessionResult) => void;
export type LoadFontCallback = (data: LoadFontResult) => void;
export type RenderTextCallback = (data: RenderTextResult) => void;
export type ResultCallback = (data: Result) => void;

export type ResultMessage = {
    id: string;
    payload: Result;
};

export { type Font, type RenderedText, type SessionId, TextBounds, TextProperties };
